import React, { useEffect, useState } from 'react';
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Navbar, Button, Modal } from 'react-bootstrap';
import { useIdleTimer } from "react-idle-timer";

export const NavigationBar = ({ resetFn }) => {
    const { instance } = useMsal();
    const [, setRemaining] = useState(0);
    const [showRefresh, setShowRefresh] = useState(false);
    // const handleLoginRedirect = async () => {
    //     await instance.initialize();
    //     instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    // };

    const handleLogoutRedirect = () => {
        instance.logoutRedirect().catch((error) => console.log(error));
    };

    const onIdle = () => {
        console.log('User is idle');
        setShowRefresh(true);
    };

    const { getRemainingTime } = useIdleTimer({
        onIdle,
        timeout: 600000
    });

    useEffect(() => {
        const interval = setInterval(() => {
          setRemaining(Math.ceil(getRemainingTime() / 1000))
        }, 500)
    
        return () => {
          clearInterval(interval)
        }
    })

    /**
     * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
     * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
     * only render their children if a user is authenticated or unauthenticated, respectively.
     */
    return (
        <>
            <Navbar variant="dark" className="navbarStyle">
                <a className="navbar-brand" href="https://www.duke-energy.com/home">
                    <img 
                        src="/assets/images/white-duke.jpg" 
                        alt="Duke Energy Logo"
                        width={150} />
                </a>
                <span className="line"></span>
                <h4>Contact Center Messaging Tool</h4>
                
                <AuthenticatedTemplate>
                    <div className="collapse navbar-collapse justify-content-end">
                        <SessionAlert 
                            show={showRefresh} 
                            refreshPage={() => window.location.reload()} 
                        />
                        <Button variant="link" onClick={resetFn}>
                            <span className='main-menu-undo'>
                               <img src="/assets/images/undo.png" alt="undo" width="20"/>
                                <p>Main Menu</p> 
                            </span>
                        </Button>
                        <Button onClick={handleLogoutRedirect} variant="link">
                            Sign out
                        </Button>
                    </div>
                </AuthenticatedTemplate>
                {/* <UnauthenticatedTemplate>
                    <div className="collapse navbar-collapse justify-content-end">
                        <Button variant="link" onClick={resetFn}>
                            <span className='main-menu-undo'>
                               <img src="/assets/images/undo.png" alt="undo" width="20"/>
                                <p>Main Menu</p> 
                            </span>
                        </Button>
                        <Button onClick={handleLogoutRedirect} variant="link">
                            Sign out
                        </Button>
                    </div>
                </UnauthenticatedTemplate> */}
            </Navbar>
        </>
    );
};

const SessionAlert = ({ show, refreshPage }) => (
    <Modal show={show}>
        <Modal.Header>
            <Modal.Title>Session Expired</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your session has expired. Click to refresh.</Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={refreshPage}>
                Refresh
            </Button>
        </Modal.Footer>
    </Modal>
)